/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Megaphone({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} clipPath="url(#Megaphone_svg__a)"><path strokeLinejoin="round" d="m6.991 9.906-.955 4.28a1 1 0 0 1-.976.782h-.977a1 1 0 0 1-.976-1.217l.858-3.845" /><path d="M14.603 5.453v2.531M5.526 4.187V9.25M12.585 11.403v-9.37c0-.88-1.057-1.331-1.693-.72l-.521.5c-.745.715-1.738 2.115-2.77 2.115H4.188a2.79 2.79 0 1 0 0 5.581h3.413c1.032 0 2.025 1.4 2.77 2.115l.521.5c.636.61 1.693.16 1.693-.72Z" /></g><defs><clipPath id="Megaphone_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;